export default __webpack_public_path__ + "static/media/check.0c32293c.png";